import { IIsiDataTransferObject } from "./Isilog.IsiFramework.IsiDataTransferObject";
import { IsiDataTransferObject } from "./Isilog.IsiFramework.IsiDataTransferObject";
import { IIsiDtoPresentationLogicResponse } from "./Isilog.IsiComponent.IsiDataTransferObject";
import { IsiDtoPresentationLogicResponse } from "./Isilog.IsiComponent.IsiDataTransferObject";
import { IIsiDtoPresentationLogicRequest } from "./Isilog.IsiComponent.IsiDataTransferObject";
import { IsiDtoPresentationLogicRequest } from "./Isilog.IsiComponent.IsiDataTransferObject";

export interface IIsiDtoPlMergeModelMergeResult extends IIsiDataTransferObject  {
    errorMsg?: string;
    files?: string[];
}
export class IsiDtoPlMergeModelMergeResult extends IsiDataTransferObject implements IIsiDtoPlMergeModelMergeResult {
    $type?: string = "Isilog.IsiComponent.IsiDataTransferObject.Merge.IsiDtoPlMergeModelMergeResult, Isilog.IsiComponent.IsiDataTransferObject";
    errorMsg?: string;
    files?: string[];

    constructor(data?: IIsiDtoPlMergeModelMergeResult) {
        super(data);
        if (data) {
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.errorMsg = _data["errorMsg"] !== undefined ? _data["errorMsg"] : <any>null;
            this.files = _data["files"] !== undefined ? _data["files"] : [];
        }
    }

    static fromJS(data?: IIsiDtoPlMergeModelMergeResult): IsiDtoPlMergeModelMergeResult {
        data = typeof data === 'object' ? data : {};
        let result = new IsiDtoPlMergeModelMergeResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any): any {
        data = super.toJSON(data);

        data["$type"] = this.$type;
        data["errorMsg"] = this.errorMsg !== undefined ? this.errorMsg : <any>null;
        data["files"] = this.files !== undefined ? this.files : [];
        return data;
    }
}
export interface IIsiDtoPlMergeModelResponse extends IIsiDtoPresentationLogicResponse  {
    exportInfos?: IIsiDtoPlExportInfo;
    mergeMailPjResult?: IIsiDtoPlMergeModelMergeMailPjResult;
    mergeResult?: IIsiDtoPlMergeModelMergeResult;
}
export interface IIsiDtoPlExportInfo extends IIsiDtoPresentationLogicResponse  {
    screenType?: ScreenType;
    screenHierName?: string;
}
export enum ScreenType {
    TGRID = 0,
    TFORM = 1,
    TVT = 2,
    TFormSearch = 3,
}
export class IsiDtoPlExportInfo extends IsiDtoPresentationLogicResponse implements IIsiDtoPlExportInfo {
    $type?: string = "Isilog.IsiComponent.IsiDataTransferObject.Merge.IsiDtoPlExportInfo, Isilog.IsiComponent.IsiDataTransferObject";
    screenType?: ScreenType;
    screenHierName?: string;

    constructor(data?: IIsiDtoPlExportInfo) {
        super(data);
        if (data) {
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.screenType = _data["screenType"] !== undefined ? _data["screenType"] : ScreenType.TGRID;
            this.screenHierName = _data["screenHierName"] !== undefined ? _data["screenHierName"] : <any>null;
        }
    }

    static fromJS(data?: IIsiDtoPlExportInfo): IsiDtoPlExportInfo {
        data = typeof data === 'object' ? data : {};
        let result = new IsiDtoPlExportInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any): any {
        data = super.toJSON(data);

        data["$type"] = this.$type;
        data["screenType"] = this.screenType !== undefined ? this.screenType : ScreenType.TGRID;
        data["screenHierName"] = this.screenHierName !== undefined ? this.screenHierName : <any>null;
        return data;
    }
}
export interface IIsiDtoPlMergeModelMergeMailPjResult extends IIsiDataTransferObject  {
    erreur?: string;
    file?: string;
    dto?: IIsiDtoAttachedFileItem;
}
export interface IIsiDtoAttachedFileItem extends IIsiDataTransferObject  {
    /** indique si la pièce jointe est de type bookmark */
    bookmark?: boolean;
    /** Type de la pièce jointe */
    typePieceJointe?: number;
    /** latitude
  */
    latitude?: number;
    /** longitude */
    longitude?: number;
    /** Url d'accès complet à la PJ */
    accessUrl?: string;
    /** Indique si la pièce jointe n'existe pas et qu'elle doit être fusionnée avant d'être utilisable. */
    needMerge?: boolean;
    default?: boolean;
    fileIcon?: string;
    fileExt?: string;
    fileType?: string;
    fileTable?: string;
    fileUploadDate?: string;
    fileUploader?: string;
    fileSize?: string;
    fileName?: string;
    recordKey?: string;
}
export class IsiDtoAttachedFileItem extends IsiDataTransferObject implements IIsiDtoAttachedFileItem {
    $type?: string = "Isilog.IsiFramework.IsiDataTransferObject.WebGUI.Components.AttachedFile.IsiDtoAttachedFileItem, Isilog.IsiFramework.IsiDataTransferObject";
    /** indique si la pièce jointe est de type bookmark */
    bookmark?: boolean;
    /** Type de la pièce jointe */
    typePieceJointe?: number;
    /** latitude
  */
    latitude?: number;
    /** longitude */
    longitude?: number;
    /** Url d'accès complet à la PJ */
    accessUrl?: string;
    /** Indique si la pièce jointe n'existe pas et qu'elle doit être fusionnée avant d'être utilisable. */
    needMerge?: boolean;
    default?: boolean;
    fileIcon?: string;
    fileExt?: string;
    fileType?: string;
    fileTable?: string;
    fileUploadDate?: string;
    fileUploader?: string;
    fileSize?: string;
    fileName?: string;
    recordKey?: string;

    constructor(data?: IIsiDtoAttachedFileItem) {
        super(data);
        if (data) {
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.bookmark = _data["bookmark"] !== undefined ? _data["bookmark"] : false;
            this.typePieceJointe = _data["typePieceJointe"] !== undefined ? _data["typePieceJointe"] : null;
            this.latitude = _data["latitude"] !== undefined ? _data["latitude"] : null;
            this.longitude = _data["longitude"] !== undefined ? _data["longitude"] : null;
            this.accessUrl = _data["accessUrl"] !== undefined ? _data["accessUrl"] : <any>null;
            this.needMerge = _data["needMerge"] !== undefined ? _data["needMerge"] : false;
            this.default = _data["default"] !== undefined ? _data["default"] : false;
            this.fileIcon = _data["fileIcon"] !== undefined ? _data["fileIcon"] : <any>null;
            this.fileExt = _data["fileExt"] !== undefined ? _data["fileExt"] : <any>null;
            this.fileType = _data["fileType"] !== undefined ? _data["fileType"] : <any>null;
            this.fileTable = _data["fileTable"] !== undefined ? _data["fileTable"] : <any>null;
            this.fileUploadDate = _data["fileUploadDate"] !== undefined ? _data["fileUploadDate"] : <any>null;
            this.fileUploader = _data["fileUploader"] !== undefined ? _data["fileUploader"] : <any>null;
            this.fileSize = _data["fileSize"] !== undefined ? _data["fileSize"] : <any>null;
            this.fileName = _data["fileName"] !== undefined ? _data["fileName"] : <any>null;
            this.recordKey = _data["recordKey"] !== undefined ? _data["recordKey"] : <any>null;
        }
    }

    static fromJS(data?: IIsiDtoAttachedFileItem): IsiDtoAttachedFileItem {
        data = typeof data === 'object' ? data : {};
        let result = new IsiDtoAttachedFileItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any): any {
        data = super.toJSON(data);

        data["$type"] = this.$type;
        data["bookmark"] = this.bookmark !== undefined ? this.bookmark : false;
        data["typePieceJointe"] = this.typePieceJointe !== undefined ? this.typePieceJointe : null;
        data["latitude"] = this.latitude !== undefined ? this.latitude : null;
        data["longitude"] = this.longitude !== undefined ? this.longitude : null;
        data["accessUrl"] = this.accessUrl !== undefined ? this.accessUrl : <any>null;
        data["needMerge"] = this.needMerge !== undefined ? this.needMerge : false;
        data["default"] = this.default !== undefined ? this.default : false;
        data["fileIcon"] = this.fileIcon !== undefined ? this.fileIcon : <any>null;
        data["fileExt"] = this.fileExt !== undefined ? this.fileExt : <any>null;
        data["fileType"] = this.fileType !== undefined ? this.fileType : <any>null;
        data["fileTable"] = this.fileTable !== undefined ? this.fileTable : <any>null;
        data["fileUploadDate"] = this.fileUploadDate !== undefined ? this.fileUploadDate : <any>null;
        data["fileUploader"] = this.fileUploader !== undefined ? this.fileUploader : <any>null;
        data["fileSize"] = this.fileSize !== undefined ? this.fileSize : <any>null;
        data["fileName"] = this.fileName !== undefined ? this.fileName : <any>null;
        data["recordKey"] = this.recordKey !== undefined ? this.recordKey : <any>null;
        return data;
    }
}
export class IsiDtoPlMergeModelMergeMailPjResult extends IsiDataTransferObject implements IIsiDtoPlMergeModelMergeMailPjResult {
    $type?: string = "Isilog.IsiComponent.IsiDataTransferObject.Merge.IsiDtoPlMergeModelMergeMailPjResult, Isilog.IsiComponent.IsiDataTransferObject";
    erreur?: string;
    file?: string;
    dto?: IsiDtoAttachedFileItem;

    constructor(data?: IIsiDtoPlMergeModelMergeMailPjResult) {
        super(data);
        if (data) {
            this.dto = data.dto && !(<any>data.dto).toJSON ? new IsiDtoAttachedFileItem(data.dto) : <IsiDtoAttachedFileItem>this.dto;
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.erreur = _data["erreur"] !== undefined ? _data["erreur"] : <any>null;
            this.file = _data["file"] !== undefined ? _data["file"] : <any>null;
            this.dto = _data["dto"] ? IsiDtoAttachedFileItem.fromJS(_data["dto"]) : <any>null;
        }
    }

    static fromJS(data?: IIsiDtoPlMergeModelMergeMailPjResult): IsiDtoPlMergeModelMergeMailPjResult {
        data = typeof data === 'object' ? data : {};
        let result = new IsiDtoPlMergeModelMergeMailPjResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any): any {
        data = super.toJSON(data);

        data["$type"] = this.$type;
        data["erreur"] = this.erreur !== undefined ? this.erreur : <any>null;
        data["file"] = this.file !== undefined ? this.file : <any>null;
        data["dto"] = this.dto != null ? (<any>this.dto).toJSON() : <any>null;
        return data;
    }
}
export class IsiDtoPlMergeModelResponse extends IsiDtoPresentationLogicResponse implements IIsiDtoPlMergeModelResponse {
    $type?: string = "Isilog.IsiComponent.IsiDataTransferObject.Merge.IsiDtoPlMergeModelResponse, Isilog.IsiComponent.IsiDataTransferObject";
    exportInfos?: IsiDtoPlExportInfo;
    mergeMailPjResult?: IsiDtoPlMergeModelMergeMailPjResult;
    mergeResult?: IsiDtoPlMergeModelMergeResult;

    constructor(data?: IIsiDtoPlMergeModelResponse) {
        super(data);
        if (data) {
            this.exportInfos = data.exportInfos && !(<any>data.exportInfos).toJSON ? new IsiDtoPlExportInfo(data.exportInfos) : <IsiDtoPlExportInfo>this.exportInfos;
            this.mergeMailPjResult = data.mergeMailPjResult && !(<any>data.mergeMailPjResult).toJSON ? new IsiDtoPlMergeModelMergeMailPjResult(data.mergeMailPjResult) : <IsiDtoPlMergeModelMergeMailPjResult>this.mergeMailPjResult;
            this.mergeResult = data.mergeResult && !(<any>data.mergeResult).toJSON ? new IsiDtoPlMergeModelMergeResult(data.mergeResult) : <IsiDtoPlMergeModelMergeResult>this.mergeResult;
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.exportInfos = _data["exportInfos"] ? IsiDtoPlExportInfo.fromJS(_data["exportInfos"]) : <any>null;
            this.mergeMailPjResult = _data["mergeMailPjResult"] ? IsiDtoPlMergeModelMergeMailPjResult.fromJS(_data["mergeMailPjResult"]) : <any>null;
            this.mergeResult = _data["mergeResult"] ? IsiDtoPlMergeModelMergeResult.fromJS(_data["mergeResult"]) : <any>null;
        }
    }

    static fromJS(data?: IIsiDtoPlMergeModelResponse): IsiDtoPlMergeModelResponse {
        data = typeof data === 'object' ? data : {};
        let result = new IsiDtoPlMergeModelResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any): any {
        data = super.toJSON(data);

        data["$type"] = this.$type;
        data["exportInfos"] = this.exportInfos != null ? (<any>this.exportInfos).toJSON() : <any>null;
        data["mergeMailPjResult"] = this.mergeMailPjResult != null ? (<any>this.mergeMailPjResult).toJSON() : <any>null;
        data["mergeResult"] = this.mergeResult != null ? (<any>this.mergeResult).toJSON() : <any>null;
        return data;
    }
}
export interface IIsiDtoPlMergeModelRequest extends IIsiDtoPresentationLogicRequest  {
    errorCode?: number;
    screenName?: string;
    returnType?: string;
    codeDocole?: number;
    response?: IIsiDtoPlMergeModelResponse;
    endSequence?: string;
    startSequence?: string;
    useSequence?: boolean;
    modelType?: string;
    codeModel?: number;
    associatedViewContextId?: string;
    screenDesignName?: string;
    screenType?: number;
    dataRestricted?: boolean;
    suffixeSequence?: string;
    prefixeSequence?: string;
    displayResults?: boolean;
    attachment?: boolean;
    mergeOnlyCurrentRecord?: boolean;
    modelName?: string;
}
export class IsiDtoPlMergeModelRequest extends IsiDtoPresentationLogicRequest implements IIsiDtoPlMergeModelRequest {
    $type?: string = "Isilog.IsiComponent.IsiDataTransferObject.Merge.IsiDtoPlMergeModelRequest, Isilog.IsiComponent.IsiDataTransferObject";
    errorCode?: number;
    screenName?: string;
    returnType?: string;
    codeDocole?: number;
    response?: IsiDtoPlMergeModelResponse;
    endSequence?: string;
    startSequence?: string;
    useSequence?: boolean;
    modelType?: string;
    codeModel?: number;
    associatedViewContextId?: string;
    screenDesignName?: string;
    screenType?: number;
    dataRestricted?: boolean;
    suffixeSequence?: string;
    prefixeSequence?: string;
    displayResults?: boolean;
    attachment?: boolean;
    mergeOnlyCurrentRecord?: boolean;
    modelName?: string;

    constructor(data?: IIsiDtoPlMergeModelRequest) {
        super(data);
        if (data) {
            this.response = data.response && !(<any>data.response).toJSON ? new IsiDtoPlMergeModelResponse(data.response) : <IsiDtoPlMergeModelResponse>this.response;
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.errorCode = _data["errorCode"] !== undefined ? _data["errorCode"] : 0;
            this.screenName = _data["screenName"] !== undefined ? _data["screenName"] : <any>null;
            this.returnType = _data["returnType"] !== undefined ? _data["returnType"] : <any>null;
            this.codeDocole = _data["codeDocole"] !== undefined ? _data["codeDocole"] : 0;
            this.response = _data["response"] ? IsiDtoPlMergeModelResponse.fromJS(_data["response"]) : <any>null;
            this.endSequence = _data["endSequence"] !== undefined ? _data["endSequence"] : <any>null;
            this.startSequence = _data["startSequence"] !== undefined ? _data["startSequence"] : <any>null;
            this.useSequence = _data["useSequence"] !== undefined ? _data["useSequence"] : false;
            this.modelType = _data["modelType"] !== undefined ? _data["modelType"] : <any>null;
            this.codeModel = _data["codeModel"] !== undefined ? _data["codeModel"] : 0;
            this.associatedViewContextId = _data["associatedViewContextId"] !== undefined ? _data["associatedViewContextId"] : <any>null;
            this.screenDesignName = _data["screenDesignName"] !== undefined ? _data["screenDesignName"] : <any>null;
            this.screenType = _data["screenType"] !== undefined ? _data["screenType"] : 0;
            this.dataRestricted = _data["dataRestricted"] !== undefined ? _data["dataRestricted"] : false;
            this.suffixeSequence = _data["suffixeSequence"] !== undefined ? _data["suffixeSequence"] : <any>null;
            this.prefixeSequence = _data["prefixeSequence"] !== undefined ? _data["prefixeSequence"] : <any>null;
            this.displayResults = _data["displayResults"] !== undefined ? _data["displayResults"] : false;
            this.attachment = _data["attachment"] !== undefined ? _data["attachment"] : false;
            this.mergeOnlyCurrentRecord = _data["mergeOnlyCurrentRecord"] !== undefined ? _data["mergeOnlyCurrentRecord"] : false;
            this.modelName = _data["modelName"] !== undefined ? _data["modelName"] : <any>null;
        }
    }

    static fromJS(data?: IIsiDtoPlMergeModelRequest): IsiDtoPlMergeModelRequest {
        data = typeof data === 'object' ? data : {};
        let result = new IsiDtoPlMergeModelRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any): any {
        data = super.toJSON(data);

        data["$type"] = this.$type;
        data["errorCode"] = this.errorCode !== undefined ? this.errorCode : 0;
        data["screenName"] = this.screenName !== undefined ? this.screenName : <any>null;
        data["returnType"] = this.returnType !== undefined ? this.returnType : <any>null;
        data["codeDocole"] = this.codeDocole !== undefined ? this.codeDocole : 0;
        data["response"] = this.response != null ? (<any>this.response).toJSON() : <any>null;
        data["endSequence"] = this.endSequence !== undefined ? this.endSequence : <any>null;
        data["startSequence"] = this.startSequence !== undefined ? this.startSequence : <any>null;
        data["useSequence"] = this.useSequence !== undefined ? this.useSequence : false;
        data["modelType"] = this.modelType !== undefined ? this.modelType : <any>null;
        data["codeModel"] = this.codeModel !== undefined ? this.codeModel : 0;
        data["associatedViewContextId"] = this.associatedViewContextId !== undefined ? this.associatedViewContextId : <any>null;
        data["screenDesignName"] = this.screenDesignName !== undefined ? this.screenDesignName : <any>null;
        data["screenType"] = this.screenType !== undefined ? this.screenType : 0;
        data["dataRestricted"] = this.dataRestricted !== undefined ? this.dataRestricted : false;
        data["suffixeSequence"] = this.suffixeSequence !== undefined ? this.suffixeSequence : <any>null;
        data["prefixeSequence"] = this.prefixeSequence !== undefined ? this.prefixeSequence : <any>null;
        data["displayResults"] = this.displayResults !== undefined ? this.displayResults : false;
        data["attachment"] = this.attachment !== undefined ? this.attachment : false;
        data["mergeOnlyCurrentRecord"] = this.mergeOnlyCurrentRecord !== undefined ? this.mergeOnlyCurrentRecord : false;
        data["modelName"] = this.modelName !== undefined ? this.modelName : <any>null;
        return data;
    }
}
